"use client";

import { cn } from "@/lib/utils";

/** A row of toggle buttons where one is chosen (All/PDF/Image, Pixels/Percent…). */
export function Segmented<T extends string>({
  label,
  options,
  value,
  onChange,
  stretch = false,
}: {
  label: string;
  options: { value: T; label: string }[];
  value: T;
  onChange: (value: T) => void;
  /** Fill the width, each button the same size. */
  stretch?: boolean;
}) {
  return (
    <div
      role="group"
      aria-label={label}
      className="flex gap-1.5 rounded-lg bg-sand p-1"
    >
      {options.map((o) => (
        <button
          key={o.value}
          type="button"
          aria-pressed={value === o.value}
          onClick={() => onChange(o.value)}
          className={cn(
            "min-h-11 rounded-[9px] px-[18px] text-[15px] text-ink",
            stretch && "flex-1 px-2",
            value === o.value
              ? "bg-card font-semibold shadow-xs"
              : "font-medium hover:bg-card/60",
          )}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
